export default {
    computed: {
        disabled() {
            return (item, list) => {
                for (let i = 0; i < list.length; i++) {
                    if (item.id === list[i].dividendId) {
                        return true;
                    }
                }
                return false;
            }
        },
    },
}